import { FC, useState } from 'react'

import { ButtonGroup } from 'ui/components/ButtonGroup'
import { Button } from 'ui/components/Buttons'
import { DocumentStatuses } from '~bank-documents/types/enums/DocumentStatuses'

import { DocumentFooterActionsProps } from './DocumentFooterActions.types'
import { ChangeStatusDialog } from './components/ChangeStatusDialog'

import * as SC from './styles'

export const DocumentFooterActions: FC<DocumentFooterActionsProps> = ({ id, flags }) => {
  const { showCanAccept, showCanIncomplete, showCanReject, showNotes, showNotesLabel } = flags
  const [openedDialogStatus, setOpenedDialogStatus] = useState<DocumentStatuses | null>(null)
  const closeDialog = () => setOpenedDialogStatus(null)

  return (
    <>
      <ChangeStatusDialog
        id={id}
        status={openedDialogStatus}
        onClose={closeDialog}
        notes={showNotes}
        notesLabel={showNotesLabel}
      />
      <ButtonGroup margin="small">
        {showCanReject && (
          <Button
            face="danger"
            onClick={() => setOpenedDialogStatus(DocumentStatuses.REJECTED)}
            data-qa="document-reject-btn"
          >
            Reject
          </Button>
        )}

        {showCanIncomplete && (
          <Button
            face="secondary"
            onClick={() => setOpenedDialogStatus(DocumentStatuses.INCOMPLETE)}
            data-qa="document-incomplete-btn"
          >
            Incomplete
          </Button>
        )}
      </ButtonGroup>

      <SC.Right>
        <ButtonGroup margin={'small'}>
          {showCanAccept && (
            <Button
              face="primary"
              onClick={() => setOpenedDialogStatus(DocumentStatuses.APPROVED)}
              data-qa="document-accept-btn"
            >
              Accept
            </Button>
          )}
        </ButtonGroup>
      </SC.Right>
    </>
  )
}
